module.exports = __webpack_public_path__ + "static/media/entree-bookcase.6c41fbac.svg";